export enum GoodPracticeSource {
  EG = 'EG', // Expert Group
  EEPA = 'EEPA', // European Enterprise Promotion Award
  EPG = 'EPG', // Enterprise Policy Group
  ECSE = 'ECSE', // European Charter for Small Enterprises
  SBAIMS = 'SBAMS', // SBA implementation in member states
}
